import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { RootState, useGetEmailInvitationsQuery } from '../store';
import LoadingLottie from '../components/atoms/LoadingLottie';
import JoinBusinessCard from '../components/JoinBusinessCard';
import InvitationDTO from '../models/invitation';
import AdminSectionTitle from '../components/AdminSectionTitle';

const InvitationsPage: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  if (!user) {
    throw new Error('no user');
  }
  const { data: invitations, isLoading, refetch } = useGetEmailInvitationsQuery({
    email: user.email,
  });

  const [pendingInvitations, setPendingInvitations] = useState<InvitationDTO[]>([]);

  useEffect(() => {
    if (invitations) {
      setPendingInvitations(invitations.filter((inv) => inv.status === 'pending'));
    }
  }, [invitations]);

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div className='my-6 flex flex-col gap-6'>
      <AdminSectionTitle title='Invitaciones' />
      <div className="flex flex-col items-center">
        {isLoading && <LoadingLottie />}
        {!isLoading && pendingInvitations && pendingInvitations.length === 0 && (
          <div className='flex flex-col items-center glass-surface w-full text-text-primary'>
            <div className='text-2xl w-full text-center my-auto font-medium'>¡Aún no tenés invitaciones pendientes!</div>
            <div className='text-md w-full text-center my-auto'>En este apartado verás las invitaciones pendientes que tengas.</div>
          </div>
        )}
        <div className={'flex flex-col gap-6 w-full'}>
          {pendingInvitations?.map((inv) => (
            <JoinBusinessCard key={inv.id} user={user} invitation={inv} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvitationsPage;
